// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"353":"c49dc12f","428":"bebac248"}[chunkId] + ".css";
};